export default __webpack_public_path__ + "static/media/logo-black.4bdf1ad8.svg";